// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tp-2";
export var chatLink = "_tp-0";
export var chatText = "_tp-1";